import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { SubjectService } from '../../../../services/subject/subject.service';
import { Subject } from '../../../../models/subjects/subject';
import { CurriculumService } from '../../../../services/curricula/curriculum.service';
import { Curriculum } from '../../../../models/curricula/curriculum';

export class CurriculumDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<Curriculum[]> = new BehaviorSubject<Curriculum[]>([]);

    get data(): Curriculum[] {
        return this.dataChange.value;
    }

    constructor(
        private curriculumService: CurriculumService
    ) {
        setTimeout(() => {
            this.curriculumService.getAll().subscribe(response => {
                console.log('curriculumn', response);
                for (const r of response) {
                    this.add(r);
                }
            }, error => {

            });
        }, 100);
    }

    public add(store: Curriculum) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: Curriculum) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: Curriculum) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/curriculumDatabase.ts